import styled from 'styled-components'

export const Container = styled.span<{characters?: number}>`
  display: inline-block;
  margin-left: 2px;
  ${({characters}): string => (characters ? `width: ${characters}ch` : '')}
`
